var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSberPayLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#sber-pay-light_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "url(#sber-pay-light_svg__b)",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M22 6.75H10a5.25 5.25 0 1 0 0 10.5h12a5.25 5.25 0 1 0 0-10.5M10 6a6 6 0 1 0 0 12h12a6 6 0 0 0 0-12z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.97 12.65v1.37h-.78v-4.4h1.46c1.39 0 1.98.5 1.98 1.49 0 1.02-.69 1.54-1.98 1.54zm0-2.3v1.58h.74c.73 0 1.11-.24 1.11-.84 0-.54-.33-.75-1.09-.75zm3.07.75c.21-.15.58-.28 1.12-.28.92 0 1.37.32 1.37 1.13v2.07h-.69v-.56c-.15.36-.53.62-1.04.62-.63 0-1.01-.36-1.01-.97 0-.72.52-.92 1.29-.92h.71v-.14c0-.45-.21-.58-.63-.58-.58 0-.91.23-1.12.56zm1.76 1.81v-.25h-.62c-.43 0-.64.08-.64.36 0 .24.18.39.5.39.5 0 .73-.28.76-.5m1.1-2.03h.82l.86 2.15.7-2.15h.78l-1.25 3.47c-.28.75-.56.92-.97.92-.19 0-.41-.06-.5-.14v-.68a.55.55 0 0 0 .38.16c.23 0 .4-.15.52-.57zm-13.18.22v.96l1.28.81 3.06-2.25a3.4 3.4 0 0 0-.4-.67L10 11.91z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.582 11.929v.07a2.586 2.586 0 1 1-1.127-2.131l.656-.481a3.359 3.359 0 1 0 1.193 2.01z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "sber-pay-light_svg__b",
  x1: 17.25,
  x2: 43.868,
  y1: 41.611,
  y2: 21.477,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#c7e701"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.242,
  stopColor: "#0ada01"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.439,
  stopColor: "#21de58"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.632,
  stopColor: "#3ee3a9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.808,
  stopColor: "#37dabe"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#15cae0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "sber-pay-light_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v24H0z"
})))));
export default SvgSberPayLight;